import editableSchedules from "./editableSchedules.component";

const editableSchedulesModule = angular
  .module("app.components.editableSchedules", [])
  .component("editableSchedules", editableSchedules);

export default editableSchedulesModule;



// WEBPACK FOOTER //
// ./src/components/editableSchedules/editableSchedules.module.js